<template>
  <div
    class="gc-multiple-choice-checkbox gc-text-center gc-h-5 gc-w-5"
    :class="[
      selected ? 'gc-bg-primary gc-text-white' : 'gc-bg-gray-300',
      singleAnswer ? 'gc-rounded-full' : 'gc-rounded',
    ]"
  >
    <font-awesome-icon v-if="selected" :icon="faCheck" />
  </div>
</template>

<script>
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

export default {
  props: {
    selected: {
      default: false,
      type: Boolean,
    },
    singleAnswer: {
      default: false,
      type: Boolean,
    },
  },
  setup: () => ({
    faCheck,
  }),
};
</script>

<style>
.gc-multiple-choice-checkbox {
  flex-shrink: 0;
  display: flex;
  cursor: pointer;
  color: white;
  font-size: 75%;
  align-items: center;
  justify-content: center;
}
</style>
